import { useCallback } from 'react';

import { useTogglePlay } from '@/scenarios/legacy-player/hooks/useTogglePlay';
import { useSeekToAir } from '@/scenarios/legacy-player/hooks/useSeekToAir';
import { useInstanceCallback } from '@/scenarios/legacy-player/hooks/useInstanceCallback';

import { PlayingState } from '../types/instance';

export const useToggleOnAir = (): {
    returnToAir: () => void;
    pause: () => void;
    toggleOnAir: () => PlayingState.play | PlayingState.pause | undefined;
} => {
    const { play, pause } = useTogglePlay();
    const seekToAir = useSeekToAir();

    const returnToAir = useCallback(() => {
        seekToAir();
        play();
    }, [play, seekToAir]);

    const toggleOnAir = useInstanceCallback(
        (instance) => {
            const playingState = instance?.playingState;

            if (!instance || !playingState) {
                return;
            }

            if ([PlayingState.buffering, PlayingState.play].includes(playingState)) {
                pause();
                // eslint-disable-next-line consistent-return
                return PlayingState.pause;
            }

            if ([PlayingState.end, PlayingState.pause].includes(playingState)) {
                returnToAir();
                // eslint-disable-next-line consistent-return
                return PlayingState.play;
            }
        },
        [returnToAir, pause]
    );

    return { toggleOnAir, returnToAir, pause };
};
